import { jax } from '~/api/core/legacy';
import { subscribeOn } from '~/state/bridge';
import { getIsInstagramSelected } from '~/state/AdPlacement/selectors';
import { allSettled } from '~/utils';

import { sendErrorService } from '~/services/error';

let isInstagramPlacement = false;
subscribeOn(getIsInstagramSelected, (isSelected) => { isInstagramPlacement = isSelected; });

export const $smallWarning = `
<div class="warn-small-img">Too Small for IG</div>
<div class="warn-small-img-hover">Pictures on Instagram need to be at least 500px by 500px. Use a single or multi-link ad with your own images, try the Google maps images for search ads, or don't run this ad on Instagram.</div>
`;

export const isSmall = ({ naturalHeight, naturalWidth }) => naturalHeight < 500 || naturalWidth < 500;

/**
 * getSmallImages
 * Returns a list of images that are too small to be posted on Instagram
 * Type is one of
 *   - fixed: fixed carousels (single/area search)
 *     not all images below top creative content/image selection are selected
 *   - variable: variable carousels (property carousel, multi(custom))
 *     all images below top creative content/image selection are selected
 * @param {String} type
 * @return {[Node]}
 */
export function getSmallImages(type) {
  if (type === 'variable') {
    return {
      all: [...document.querySelectorAll('.creative-item__thumbnail>img')]
        .filter(isSmall),
    };
  }

  if (type === 'fixed') {
    return {
      all: [...document.querySelectorAll('.creative-item__thumbnail>img')]
        .filter(isSmall),
      blocking: [...document.querySelectorAll('.image-picker__selected-searches .creative-item__thumbnail>img')]
        .filter(isSmall),
    };
  }
  throw new Error('no type provided');
}

export const addSmallWarning = img => img.before($smallWarning);
export const resetSmallWarning = img => img.siblings().not('img').detach();
export const isInstagramAd = () => isInstagramPlacement;
